import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import closeIcon from '../../images/close-icon.svg';
import { ensureModalRoot } from '../shared/modal/modalRoot';

import {
  FeatureScreenLightboxClose,
  FeatureScreenLightboxImage,
  FeatureScreenLightboxInner,
  FeatureScreenLightboxOverlay,
  FeatureScreenLightboxStage,
} from './landingPage.styles';

export default function LandingFeatureScreenLightbox({ image, alt, onClose }) {
  useEffect(() => {
    if (!image) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [image, onClose]);

  if (!image) return null;

  const modalRoot = ensureModalRoot();
  if (!modalRoot) return null;

  return createPortal(
    <FeatureScreenLightboxOverlay
      role="dialog"
      aria-modal="true"
      aria-label={alt}
      onClick={onClose}
    >
      <FeatureScreenLightboxStage onClick={(event) => event.stopPropagation()}>
        <FeatureScreenLightboxClose type="button" aria-label="Close" onClick={onClose}>
          <img src={closeIcon} alt="" />
        </FeatureScreenLightboxClose>

        <FeatureScreenLightboxInner>
          <FeatureScreenLightboxImage src={image} alt={alt} />
        </FeatureScreenLightboxInner>
      </FeatureScreenLightboxStage>
    </FeatureScreenLightboxOverlay>,
    modalRoot,
  );
}
